<template>
    <div>
        <h1 style="font-size: 24px; color: black;">视频日报
            <span>用户类型：</span>
            <el-select v-model="queryData.user" clearable placeholder="请选择">
                <el-option v-for="item in users" :label="item.name" :key="item.id" :value="item.id"></el-option>
            </el-select>
        </h1>
        <div class="block">
            <span>游戏名称：</span>
            <el-select v-model="queryData.gameId" @change="selectVideosByGameId($event)" clearable filterable
                       multiple  placeholder="请选择/输入">
                <el-option
                    v-for="item in gameList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
            <span>视频名称：</span>
            <el-select v-model="queryData.videoIds" clearable multiple filterable placeholder="请选择/输入">
                <el-option
                    v-for="item in showVideoList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
            <span class="demonstration">日期：</span>
            <el-date-picker
                v-model="queryData.timeDate"
                type="daterange"
:clearable="false"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
            </el-date-picker>&emsp;&emsp;
            <span >渠道：</span>
            <el-select v-model="queryData.channelId"  @change="selectGoodsByChannelId($event)" clearable placeholder="请选择" multiple>
                <el-option value="0" label="全部"></el-option>
                <el-option v-for="item in channelList" :label="item.name" :key="item.id" :value="item.id"></el-option>
            </el-select>
            <el-select v-model="queryData.subChannelId"   clearable placeholder="请选择" multiple filterable @change="checkParam($event)">
                <el-option value="0" label="全部"></el-option>
                <el-option v-for="item in subChannelList" :label="item.name" :key="item.id" :value="item.subChannel" :disabled="item.disabled"></el-option>
            </el-select>
            <el-button type="primary" @click="query">查询</el-button>
            <el-button type="primary" @click="exportExcel()">导出</el-button>
        </div>
        <h1>
            <el-table :key="tableKey"
                      :data="videoReport"
                      border
                      :header-cell-style="{background:'#282828'}"
                      ref="filterTable"
                      max-height="820" @sort-change='sortChange'>
                <el-table-column prop="dt" label="日期" sortable='custom'></el-table-column>
                <el-table-column prop="gameName" label="游戏名称"></el-table-column>
                <el-table-column prop="videoName" label="视频名称"></el-table-column>
                <el-table-column label="视频缩略图">
                    <template slot-scope="scope">
                        <img :src="VUE_APP_CDN_URL+scope.row.videoImage" width="80px" height="80px" alt=""/>
                    </template>
                </el-table-column>
                <el-table-column label="点击用户数" sortable='custom' prop="clUser">
                    <template slot-scope="scope">
                        {{ scope.row.clUser == null ? '0' : scope.row.clUser }}
                    </template>
                </el-table-column>

                <el-table-column label="曝光用户数" sortable='custom' prop="exUser">
                    <template slot-scope="scope">
                        {{ scope.row.exUser == null ? '0' : scope.row.exUser }}
                    </template>
                </el-table-column>

                <el-table-column label="用户点击率" sortable='custom' prop="clRate">
                    <template slot-scope="scope">
                        {{ scope.row.clRate == null ? '0.00%' : (scope.row.clRate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>

                <el-table-column label="曝光率" sortable='custom' prop="exRate">
                    <template slot-scope="scope">
                        {{ scope.row.exRate == null ? '0.00%' : (scope.row.exRate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>

                <el-table-column label="人均点击次数" sortable='custom' prop="clPerUser">
                    <template slot-scope="scope">
                        {{ scope.row.clPerUser == null ? '0.00' : scope.row.clPerUser.toFixed(2) }}
                    </template>
                </el-table-column>

                <el-table-column label="游戏新增" sortable='custom' prop="newUser">
                    <template slot-scope="scope">
                        {{ scope.row.newUser == null ? '0' : scope.row.newUser }}
                    </template>
                </el-table-column>
                <el-table-column label="游戏次留" sortable='custom' prop="r1Rate">
                    <template slot-scope="scope">
                        {{ scope.row.r1Rate == null ? '0.00' : scope.row.r1Rate.toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column label="游戏人均时长" sortable='custom' prop="perOnline">
                    <template slot-scope="scope">
                        {{ scope.row.perOnline == null ? '0.00' : scope.row.perOnline.toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column label="游戏人均频次" sortable='custom' prop="perGameTimes">
                    <template slot-scope="scope">
                        {{ scope.row.perGameTimes == null ? '0.00' : scope.row.perGameTimes.toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column label="游戏1分钟占比" sortable='custom' prop="less1Rate">
                    <template slot-scope="scope">
                        {{ scope.row.less1Rate == null ? '0.00%' : (scope.row.less1Rate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>
                <el-table-column label="人均广告视频次数" sortable='custom' prop="perOnline">
                    <template slot-scope="scope">
                        {{scope.row.perVideo==null?'0.00':scope.row.perVideo.toFixed(2)}}
                    </template>
                </el-table-column>

            </el-table>
            <el-row>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryInfo.pagenum"
                    :page-sizes="[20,30,50]"
                    :page-size="queryInfo.pagesize"
                    layout="total, sizes, prev, pager, next"
                    :total="queryInfo.total">
                </el-pagination>
            </el-row>
        </h1>
    </div>
</template>

<script>
import {channelList, downloadData, gameSimpleList, videoList,} from "@/http/api";
import utils from '@/utils'
import {searchVideoReport} from "../../http/api";

export default {
    inject: ['reload'],
    name: "VideoReport",
    data() {
        return {
            isIndeterminate: true,
            checkAll: false,
            tableKey: 1,
            cateList: [],
            VUE_APP_CDN_URL: null,
            queryData: {
                user: 0,
                gameId: [-1],
                videoIds: [],
                categories: [],
                channelId: [],
                subChannelId: [],
                timeDate: ['', ''],
            },
            queryInfo: {
                pagesize: 20,
                pagenum: 1,
                total: 0,
            },
            users: [{id: 0, name: '全部'},
                {id: 1, name: '新用户'},
                {id: 2, name: '老用户'}],
            subQueryData: {},
            queryTrueData: {
                gameId: -1,
                videoIds: [],
                channelId: [],
                subChannelId: [],
                startTime: '',
                order: null,
                prop: null,
                endTime: '',
            },
            videoReport: [],
            gameList: [],
            videoList: [],
            showVideoList: [],
            channelList: [],
            subChannelList: [],
            watchTag: '',
            videoTag: ''
        }
    },
    methods: {
        selectGoodsByChannelId(val) {
            if(val.length===1){
                val = val[0]
            }else{
                this.subChannelList=[];
                return;
            }
            this.watchTag = val;
            if (val !== null && val !== '' && val !== undefined && val !== '0') {
                this.subChannelList = this.channelList.filter(channel => channel.id === val)[0].children.filter(subChannel => subChannel.state === 1);
            }
            if (val === '0') {
                this.subChannelList = [];
            }
        },
        selectVideosByGameId(val) {
            this.videoTag = val;
            if (val !== null && val !== '' && val !== undefined && val !== -1) {
                this.showVideoList = this.videoList.filter(video => video.gameId === val);
            }
            if (val === -1) {
                this.showVideoList = this.videoList;
            }
        },

        handleSizeChange(newSize) {
            this.queryInfo.pagesize = newSize;
            this.searchVideoReportList();

        },
        handleCurrentChange(newPage) {
            this.queryInfo.pagenum = newPage;
            this.searchVideoReportList();
        },
        searchVideoReportList() {
            if (this.queryData.timeDate === null) {
                this.queryData.timeDate = ['', ''];
            }
            this.queryTrueData.gameId = this.queryData.gameId;
            this.queryTrueData.videoIds = this.queryData.videoIds;
            this.queryTrueData.channelId = this.queryData.channelId;
            this.queryTrueData.subChannelId = this.queryData.subChannelId;
            this.queryTrueData.startTime = this.queryData.timeDate[0];
            this.queryTrueData.endTime = this.queryData.timeDate[1];
            this.queryTrueData.size = this.queryInfo.pagesize;
            this.queryTrueData.page = this.queryInfo.pagenum;
            this.queryTrueData.user = this.queryData.user;
            searchVideoReport(this.queryTrueData).then(resp => {
                this.videoReport = resp.data.info.list;
                this.queryInfo.total = resp.data.info.totalElements;
            });
        },
        query(){
            this.queryInfo.pagenum = 1;
            this.searchVideoReportList();
        },
        exportExcel() {
            let fileName = new Date().toLocaleString() + '视频日报.xlsx';
            downloadData(
                '/video/searchVideoReportExcel',
                Object.assign(this.queryTrueData),
                fileName
            )
        },
        sortChange(order) {
            this.queryTrueData.order = order.order;
            this.queryTrueData.prop = order.prop;
            this.searchVideoReportList();
        },
        checkParam(val){
            let _this = this;
            if (val.indexOf('0') > -1){
                this.subChannelList.forEach(function (subChannel) {
                    _this.$set(subChannel,'disabled',true);
                    _this.queryData.subChannelId=['0']
                });
            }else {
                this.subChannelList.forEach(function (subChannel) {
                    _this.$set(subChannel,'disabled',false);
                });
            }

        },
    },

    watch: {
        watchTag() {
            this.queryData.subChannelId = [];
        },

        videoTag() {
            this.queryData.videoIds = [];
        }
    },

    created() {
        this.queryData.timeDate=[utils.TodayUtil.getToday(),utils.TodayUtil.getToday()];
        channelList().then(resp => {
            this.channelList = resp.data.info;
        });

        videoList().then(resp => {
            this.videoList = resp.data.info;
            this.showVideoList = resp.data.info;
        });

        gameSimpleList().then(resp => {
            this.gameList = resp.data.info;
            this.gameList.unshift({id: -1, name: '全部'});
        });

        this.searchVideoReportList();
    },
    mounted() {
        this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
    }
}
</script>

<style scoped>

</style>
